import { InsightSeverity } from './enums';

export class AnomalyUpdateParams {
  public name: string;
  public severity: InsightSeverity;
  public isActive: boolean;
}
